import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';

import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';

export const appConfig = {
    providers: [
        provideFirebaseApp(() => initializeApp(environment.firebase!)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    ],
};
